import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ForgeSelect } from '@tylertech/forge-react';

import { I18n } from 'common/i18n';
import * as constants from 'common/components/AssetBrowser/lib/constants';
import * as filters from 'common/components/AssetBrowser/actions/filters';
import { selectVersion, selectAllowedVersions } from 'common/components/AssetBrowser/selectors/filters';

export const VersionFilter = () => {
  const version = useSelector(selectVersion);
  const allowedVersions = useSelector(selectAllowedVersions);
  const dispatch = useDispatch();

  const changeVersion = (value: string | null) => {
    dispatch((filters as any).changeVersion(value));
  };

  const scope = 'shared.asset_browser.filters.version';

  const versionOptions = [
    { label: I18n.t('options.all', { scope }), value: null },
    { label: I18n.t('options.published', { scope }), value: constants.VERSION_PUBLISHED },
    {
      label: I18n.t('options.draft', { scope }),
      value: constants.VERSION_DRAFT,
    },
  ];

  return (
    <div className="filter-section version">
      <label className="filter-label">{I18n.t('label', { scope })}</label>
      <ForgeSelect
        disabled={allowedVersions && allowedVersions.length === 1}
        value={version || null}
        variant="filled"
        onChange={(event: CustomEvent) => changeVersion(event.detail || null)}
        options={versionOptions}
      />
    </div>
  );
};
